import React, { useLayoutEffect, useRef, useState } from 'react';
const MARK_SRC = 'https://cdn.magicpatterns.com/uploads/9hLnuTMWz2SuF6t6GJnLfP/image.png';
const FONT_SIZE = 200;
const BASELINE = 0;
const MARK_H = 142; // roughly the cap height of the serif at FONT_SIZE
const MARK_W = MARK_H * (848 / 886);
const GAP = 34;
export function FooterWordmark() {
  const groupRef = useRef<SVGGElement>(null);
  const [viewBox, setViewBox] = useState('0 -190 1000 250');

  // Fit the viewBox to the real rendered bounds so nothing is clipped
  // and the text keeps its natural letter spacing.
  useLayoutEffect(() => {
    const fit = () => {
      const g = groupRef.current;
      if (!g) return;
      const b = g.getBBox();
      // Small symmetric breathing room: the italic "&" and serif overhangs can extend past the
      // measured box, so pad both sides equally — keeps it centred and inside the page rails.
      const padX = b.width * 0.015;
      const padY = b.height * 0.04;
      setViewBox(`${b.x - padX} ${b.y - padY} ${b.width + padX * 2} ${b.height + padY * 2}`);
    };
    fit();
    document.fonts?.ready.then(fit);
    // Re-measure once the serif has certainly swapped in (late font loads change the width)
    const t = window.setTimeout(fit, 1200);
    return () => window.clearTimeout(t);
  }, []);
  return <svg viewBox={viewBox} preserveAspectRatio="xMidYMid meet" className="mx-auto block h-auto w-full max-w-full overflow-hidden" role="img" aria-label="Kays&Kays" data-id="element-188" data-mp="13syazq41yhk6">
      <g ref={groupRef} data-id="element-189" data-mp="1crjtjl9ixwky">
        {/* Mark: the uploaded image is used as a mask, so only the glyph is painted
            in the current colour and its background is fully transparent. */}
        <svg x={0} y={BASELINE - MARK_H} width={MARK_W} height={MARK_H} viewBox="176 170 848 886" data-id="element-190" data-mp="1mio9an70xlgu">
          <defs data-id="element-191" data-mp="1riam4vixwzp4">
            <filter id="kk-mark-knockout" colorInterpolationFilters="sRGB" data-id="element-192" data-mp="1risrqirhsq9p">
              {/* Black glyph → white (shown), red background → black (hidden) */}
              <feColorMatrix type="matrix" values="-0.638 -2.146 -0.217 0 1  -0.638 -2.146 -0.217 0 1  -0.638 -2.146 -0.217 0 1  0 0 0 0 1" data-id="element-193" data-mp="16s6vx0otmev9" />
            </filter>
            <mask id="kk-mark-mask" maskUnits="userSpaceOnUse" x={0} y={0} width={1200} height={1200} data-id="element-194" data-mp="1girr0e5ad19f">
              <image href={MARK_SRC} width={1200} height={1200} filter="url(#kk-mark-knockout)" data-id="element-195" data-mp="1br9rluiwv8qk" />
            </mask>
          </defs>
          <rect width={1200} height={1200} fill="currentColor" mask="url(#kk-mark-mask)" data-id="element-196" data-mp="1phd9k9arcga7" />
        </svg>
        <text x={MARK_W + GAP} y={BASELINE} fill="currentColor" className="font-serif" style={{
        fontSize: FONT_SIZE,
        letterSpacing: '-0.015em'
      }} data-id="element-197" data-mp="1kjlhnfa44u60">
          Kays
          <tspan fontStyle="italic" dx={2} data-id="element-198" data-mp="1ug6pe8diojdj">&amp;</tspan>
          <tspan dx={2} data-id="element-199" data-mp="53w5c8881zjd">Kays</tspan>
        </text>
      </g>
    </svg>;
}